export const frSimulations = {
  generalError:
    'La simulation demandée n’a pas pu être chargée. Veuillez actualiser la page et communiquer avec le soutien technique si le problème persiste.',
  start: 'Commencer la simulation',
  reloadForEquipmentWarning:
    'REMARQUE : Si du matériel manque, actualisez votre navigateur et recommencez.',
};
